import RoutePathEnum from "../enums/RoutePathEnum";
import Login from "../old/pages/Login";
import FederatedTokenLogin from "../old/pages/FederatedTokenLogin";
import LoginDashboard from "../old/pages/LoginDashboard";
import ForgotPassword from "../old/pages/ForgotPassword";
import ForgotPasswordFinish from "../new/pages/ResetPassword/ForgotPasswordFinish";
import AccountConflict from "../old/pages/AccountConflict";
import LoginDashboardPopup from "../old/pages/LoginDashboardPopup";
import AccountUnification from "../old/pages/AccountUnification";
import Dashboard from "../new/pages/Dashboard";
import Users from "../new/pages/Users/Users";
import UserUpdate from "../new/pages/Users/UserUpdate";
import ChangePassword from "../new/pages/ResetPassword/ChangePassword";
import UserDeleted from "../new/pages/Deleted/Users/UserDeleted";
import OrganizationDeleted from "../new/pages/Deleted/Organizations/OrganizationDeleted";
import Resellers from "../new/pages/Resellers/Resellers";
import ResellerCreate from "../new/pages/Resellers/ResellerCreate";
import OrganizationCreate from '../new/pages/Organizations/OrganizationCreate'
import Organizations from "../new/pages/Organizations/Organizations";
import MaintenanceMode from "@/new/pages/SystemSettings/MaintenanceMode";
import MaintenanceModeDashboard from "@/new/pages/SystemSettings/MaintenanceModeDashboard";
import axios from 'axios';
import store from "../store";

import AuthService from "../new/services/AuthService";
import OrganizationLogin from "@/new/pages/OrganizationLogin/Login";
import OrganizationForgotPassword from "@/new/pages/OrganizationLogin/ForgotPassword";
import colorHelper from "@/js/colorHelper";
import FederatedEmailLogin from "../old/pages/FederatedEmailLogin";

function handleCustomOrganizationPage(to, from, next) {
    if (AuthService.isLogged()) {
        next(RoutePathEnum.DASHBOARD)
        return;
    }
    let url = process.env.VUE_APP_API_URL + '/custom-login-page/' + to.params.organization;
    axios.get(url)
        .then(response => {
            response = response.response
            if (response.status === 200) {
                store.commit('loginPage/setData', response.data.data);
                if (response.data.data.color) {
                    colorHelper.setDocumentAccentColor(response.data.data.color)
                }
                next();
            } else {
                next(RoutePathEnum.LOGIN);
            }
        })
        .catch(() => {
            next(RoutePathEnum.LOGIN);
        });
    next();
}

function getRoutesPath() {

    let routes = [
        /** Old pages **/
        {
            path: RoutePathEnum.LOGIN,
            component: Login,
            // Before we open default login page we need to reset custom organization colors. Because when we logout from SPA we redirect to default login page.
            beforeEnter: (to, from, next) => {
                colorHelper.resetColors();
                next();
            }
        },
        {
            path: RoutePathEnum.FEDERATED_TOKEN_LOGIN,
            component: FederatedTokenLogin,
        },
        {
            path: RoutePathEnum.FEDERATED_EMAIL_LOGIN,
            component: FederatedEmailLogin,
        },
        {path: RoutePathEnum.LOGIN_DASHBOARD_POPUP, component: LoginDashboardPopup},
        {path: RoutePathEnum.FORGOT_PASSWORD, component: ForgotPassword},
        {path: RoutePathEnum.ACCOUNT_CONFLICT, component: AccountConflict},
        {path: RoutePathEnum.FORGOT_PASSWORD_FINISH, component: ForgotPasswordFinish},
        {path: RoutePathEnum.LOGIN_DASHBOARD, component: LoginDashboard},
        {path: RoutePathEnum.ACCOUNT_UNIFICATION, component: AccountUnification},

        {path: RoutePathEnum.MAINTENANCE_MODE_DASHBOARD, component: MaintenanceModeDashboard},

        /** New pages **/
        {path: RoutePathEnum.DASHBOARD, component: Dashboard},
        {path: RoutePathEnum.USERS, component: Users},
        {path: RoutePathEnum.DELETED_USERS, component: UserDeleted},
        {path: RoutePathEnum.USER_UPDATE, component: UserUpdate},
        {path: RoutePathEnum.CHANGE_PASSWORD, component: ChangePassword},

        {path: RoutePathEnum.MAINTENANCE_MODE, component: MaintenanceMode},
    ];

    if (process.env.VUE_APP_FEATURE_AVALIABLE_RESELLERS === 'true') {
        routes.push({path: RoutePathEnum.RESELLERS, component: Resellers});
        routes.push({path: RoutePathEnum.RESELLER_UPDATE, component: ResellerCreate});
        routes.push({path: RoutePathEnum.RESELLERS_CREATE, component: ResellerCreate});
    }
    if (process.env.VUE_APP_FEATURE_AVALIABLE_ORGANIZATIONS === 'true') {
        routes.push({path: RoutePathEnum.ORGANIZATIONS, component: Organizations});
        routes.push({path: RoutePathEnum.DELETED_ORGANIZATIONS, component: OrganizationDeleted});
        routes.push({path: RoutePathEnum.ORGANIZATION_CREATE, component: OrganizationCreate});
        routes.push({path: RoutePathEnum.ORGANIZATION_UPDATE, component: OrganizationCreate});
    }

    routes.push({
        path: RoutePathEnum.CUSTOM_LOGIN,
        component: OrganizationLogin,
        name: 'CustomOrganizationLoginPage',
        beforeEnter: (to, from, next) => {
            handleCustomOrganizationPage(to, from, next)
        }
    })
    routes.push({
        path: RoutePathEnum.CUSTOM_FORGOT_PASSWORD,
        component: OrganizationForgotPassword,
        name: 'CustomOrganizationForgotPassword',
        beforeEnter: (to, from, next) => {
            handleCustomOrganizationPage(to, from, next)
        }
    })

    return routes;
}

export default getRoutesPath()
